/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Max_Speed_KnotsInputs */

const en_field_max_speed_knots = /** @type {(inputs: Field_Max_Speed_KnotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max Speed (knots)`)
};

const es_field_max_speed_knots = /** @type {(inputs: Field_Max_Speed_KnotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad máxima (nudos)`)
};

const fr_field_max_speed_knots = /** @type {(inputs: Field_Max_Speed_KnotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitesse max (nœuds)`)
};

const de_field_max_speed_knots = /** @type {(inputs: Field_Max_Speed_KnotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höchstgeschwindigkeit (Knoten)`)
};

const ja_field_max_speed_knots = /** @type {(inputs: Field_Max_Speed_KnotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大速度 (ノット)`)
};

const zh_field_max_speed_knots = /** @type {(inputs: Field_Max_Speed_KnotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最高航速 (节)`)
};

const ar_field_max_speed_knots = /** @type {(inputs: Field_Max_Speed_KnotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السرعة القصوى (بالعقدة)`)
};

const id_field_max_speed_knots = /** @type {(inputs: Field_Max_Speed_KnotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kecepatan Maks (knots)`)
};

const it_field_max_speed_knots = /** @type {(inputs: Field_Max_Speed_KnotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocità Max (nodi)`)
};

const ru_field_max_speed_knots = /** @type {(inputs: Field_Max_Speed_KnotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Макс. скорость (узлы)`)
};

const pt_field_max_speed_knots = /** @type {(inputs: Field_Max_Speed_KnotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidade Máxima (nós)`)
};

const ko_field_max_speed_knots = /** @type {(inputs: Field_Max_Speed_KnotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최고 속도 (노트)`)
};

/**
* | output |
* | --- |
* | "Max Speed (knots)" |
*
* @param {Field_Max_Speed_KnotsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_max_speed_knots = /** @type {((inputs?: Field_Max_Speed_KnotsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Max_Speed_KnotsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_max_speed_knots(inputs)
	if (locale === "es") return es_field_max_speed_knots(inputs)
	if (locale === "fr") return fr_field_max_speed_knots(inputs)
	if (locale === "de") return de_field_max_speed_knots(inputs)
	if (locale === "ja") return ja_field_max_speed_knots(inputs)
	if (locale === "zh") return zh_field_max_speed_knots(inputs)
	if (locale === "ar") return ar_field_max_speed_knots(inputs)
	if (locale === "id") return id_field_max_speed_knots(inputs)
	if (locale === "it") return it_field_max_speed_knots(inputs)
	if (locale === "ru") return ru_field_max_speed_knots(inputs)
	if (locale === "pt") return pt_field_max_speed_knots(inputs)
	return ko_field_max_speed_knots(inputs)
});